module.exports = {
    SVG_ALERT_WARNING: '<svg svg data-id="SVG_ALERT_WARNING" width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
    '    <title>Artboard 14</title>\n' +
    '    <desc>Created with Sketch.</desc>\n' +
    '    <defs></defs>\n' +
    '    <g id="Artboard-14" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
    '        <g id="-Icon---βeta-/-System-Controls-/-Alert-Circle-/-1---24-/-3---Red" transform="translate(-2.000000, -2.000000)">\n' +
    '            <g id="Group" transform="translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) translate(2.000000, 2.000000)">\n' +
    '                <g id="Info">\n' +
    '                    <path d="M9,5.958 C9,5.406 9.448,4.958 10,4.958 C10.553,4.958 11,5.406 11,5.958 C11,6.511 10.553,6.958 10,6.958 C9.448,6.958 9,6.511 9,5.958" id="Fill-1" fill="#DE0B0B"></path>\n' +
    '                    <path d="M10,14.2168 L10,9.1038" id="Stroke-3" stroke="#DE0B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
    '                    <path d="M0.75,10 C0.75,4.892 4.892,0.75 10,0.75 C15.108,0.75 19.25,4.892 19.25,10 C19.25,15.108 15.108,19.25 10,19.25 C4.892,19.25 0.75,15.108 0.75,10 Z" id="Stroke-5" stroke="#DE0B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
    '                </g>\n' +
    '            </g>\n' +
    '        </g>\n' +
    '    </g>\n' +
    '</svg>'};

